import React, { useMemo, useRef } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { getOptionLabel } from "common/enums";

import BaseTable from "Components/Common/BaseTable";

import ConsumerNumbersDisplay from "./ConsumerNumbersDisplay";

const RECORDS_PER_PAGE = 5;

const VerfiedConumerModal = ({ t, rowData }) => {
  const resetPageRef = useRef();

  const columns = useMemo(
    () => [
      {
        title: "Name",
        renderCell: ({ salutation, firstName, lastName }) =>
          `${getOptionLabel(
            "salutationOptions",
            salutation
          )} ${firstName} ${lastName??""}`,
      },
      {
        title: "Email",
        field: "email",
      },
      {
        title: "Mobile Number",
        field: "mobileNumber",
      },
      {
        title: "Consumer Numbers",
        renderCell: ({ authorizedUserConsumers }) => (
          <ConsumerNumbersDisplay consumerNumbers={authorizedUserConsumers} />
        ),
        columnProps: { style: { width: "25%" } },
      },
    ],
    []
  );

  return (
    <BaseTable
      data={rowData??[]}
      columns={columns}
      pagination
      pageSize={RECORDS_PER_PAGE}
      registerResetPage={(cb) => {
        resetPageRef.current = cb;
      }}
    />
  );
};

VerfiedConumerModal.propTypes = {
  t: PropTypes.func.isRequired,
  rowData: PropTypes.array,
};

export default withTranslation()(VerfiedConumerModal);
